import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
} from '@angular/core';
import { differenceInMinutes } from 'date-fns';

import { FlightTrackerLeg } from '../../types/flight-tracker-leg.type';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'jb-flight-tracker-results-animation',
  templateUrl: './flight-tracker-results-animation.component.html',
  styleUrls: ['./flight-tracker-results-animation.component.scss'],
  animations: [
    trigger('animatePlane', [
      state('1', style({ left: '0.7rem' })),
      state('0.8', style({ left: '20%' })),
      state('0.6', style({ left: '40%' })),
      state('0.4', style({ left: '60%' })),
      state('0.2', style({ left: '80%' })),
      state('0', style({ left: '100%' })),
      transition('* <=> *', animate('1500ms ease-out')),
    ]),
    trigger('animateBlueLine', [
      state('1', style({ width: '0%' })),
      state('0.8', style({ width: '18%' })),
      state('0.6', style({ width: '38%' })),
      state('0.4', style({ width: '58%' })),
      state('0.2', style({ width: '78%' })),
      state('0', style({ width: '{{blueLinePercentage}}%' }), {
        params: { blueLinePercentage: 98 },
      }),
      transition('* <=> *', animate('1500ms ease-out')),
    ]),
  ],
})
export class FlightTrackerResultsAnimationComponent implements OnChanges {
  approxPercentFlightRemaining;
  currentTime = new Date();

  @Input('flightLegData') flightLegData: FlightTrackerLeg;
  @Input('blueLinePercentage') blueLinePercentage;
  @Input('useFullWidth') useFullWidth = false;
  @Input('useCoreBlue') useCoreBlue = false;

  ngOnChanges() {
    this.calculateFlightPercentage(
      this.flightLegData.actualDeparture,
      this.flightLegData.actualArrival,
    );
  }

  calculateFlightPercentage(departureTime: string, arrivalTime: string): void {
    const departureDate = departureTime ? new Date(departureTime) : undefined;
    const arrivalDate = arrivalTime ? new Date(arrivalTime) : undefined;
    const minutesLeft = differenceInMinutes(arrivalDate, this.currentTime);
    const totalMinutes = differenceInMinutes(arrivalDate, departureDate);
    let percentageLeft = minutesLeft / totalMinutes;
    if (percentageLeft > 1) {
      percentageLeft = 1;
    } else if (percentageLeft >= 0.8) {
      percentageLeft = 0.8;
    } else if (percentageLeft >= 0.6) {
      percentageLeft = 0.6;
    } else if (percentageLeft >= 0.4) {
      percentageLeft = 0.4;
    } else if (percentageLeft > 0) {
      percentageLeft = 0.2;
    } else if (percentageLeft <= 0) {
      percentageLeft = 0;
    }
    this.approxPercentFlightRemaining = percentageLeft;
  }
}
